/* eslint-disable */
import React, { useCallback, useEffect, useState } from 'react'
import {
  Chip,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  Popover,
  makeStyles,
  Button,
  Select,
  FormGroup,
  FormControlLabel,
  Checkbox,
  withStyles,
  MenuItem,
  ListItemText,
  OutlinedInput,
  Typography,
  ListItemIcon,
  TextField
} from '@material-ui/core'
import FilterListIcon from '@material-ui/icons/FilterList'
import DoneIcon from '@material-ui/icons/Done'
import CloseIcon from '@material-ui/icons/Close'
import { green } from '@material-ui/core/colors';
import { useDispatch, useSelector } from 'react-redux';
import { getToken } from '../../../Auth';
import { StylesContext } from '@material-ui/styles'

const useStyles = makeStyles({
  paddingTopmainmenu: { marginTop: '5px', background: 'white' },
  chipfont: {
    fontFamily: 'Work Sans !important',
    color: '#000000 !important',
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '-0.2px',
    fontWeight: 400,
  },
  popper: { display: 'flex', justifyContent: 'space-evenly', alignContent: 'center' },
  popovergrid2: { padding: '5px', height: 'auto', background: 'white', width: '700px' },
  formControlchip2: {
    background: '#FFFFFF',
    marginLeft: '5px',
    marginRight: '5px',
    marginBottom: '5px',
    // minHeight: 280,
    width: 'auto',
    height: 'auto',
  },
  formControllabelstyle2: {
    marginLeft: '5px',
    marginRight: '5px',
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '16px',
    letterSpacing: '0.4px',
    color: 'black',
  },
  buttonstyle: { marginBottom: '10px', color: '#067f6f' },
  apply:{
    display: 'inline-flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    fontSize: '14px',
    width: '100%',
    height: '30px',
    border: '0px',
    background: '#067f6f',
    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.16), 0px 2px 4px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.1)',
    borderRadius: '4px',
    color:'white',
    marginBottom:'4px'
  }
});
const GreenCheckbox = withStyles({
  root: {
    color: '#DADADA',
    '&$checked': {
      color: '#2D9F86',
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

function Filter(props) {
  const { memberFilters,filteredData } = props;
  const classes = useStyles();
  // const { t } = useTranslation();
  const savedFilterData = {};
  const [anchorE2, setAnchorE2] = useState(null);
  const [chipArray, setchipArray] = useState(null);
  const makeInitData = () => {
    let initData = {};
    initData.role = {
      label: 'role',
      checked: true,
      type: 'role',
    };
    initData.team = {
      label: 'team',
      checked: true,
      type: 'team',
    };
    initData.availability = {
      label: 'availability',
      checked: true,
      type: 'availability',
    };
    initData.status = {
      label: 'status',
      checked: true,
      type: 'status',
    };
    return initData;
  };
  // initialising data
  useEffect(() => {
    let data = makeInitData();
    setchipArray(data);
  }, []);
  
  const popoveropen2 = Boolean(anchorE2);
  const popoverid2 = popoveropen2 ? 'simple-popover' : undefined;

  const handlepopover2openClick = (event) => {
    setAnchorE2(event.currentTarget);
  };
  const handlepopovercloseclick = () => {
    setAnchorE2(null);
  };

  const handlepopoverresetclick2 = useCallback(() => {
    setchipArray(makeInitData());
    setSelectedRole([])
    setSelectedTeam([])
    setSelectedLicense([])
    setSelectedManageAvailability([])
  }, [chipArray]);

  const dispatch = useDispatch();
  const [changeFilters, setChangeFilters] = useState(false);
  const [roleList, setRoleList]=useState([]);
  const [selectedRole,setSelectedRole]=useState([]);
  const [teamList,setTeamList]=useState([]);
  const [selectedTeam,setSelectedTeam]=useState([]);
  const [licenseList,setLicenseList]=useState([]);
  const[selectedLicense,setSelectedLicense]=useState([]);
  const [manageAvailability,setManageAvailability]=useState([]);
  const [selectedManageAvailability,setSelectedManageAvailability]=useState([]);
  const data = [ 'role','team','availability','status'];
  
  useEffect(() => {
    setRoleList([
      {
        value:'Admin',
        label:'Admin'
      },
      {
        value:'Provider',
        label:'Provider'
      },
      {
        value:'Both',
        label:'Both'
      },
      {
        value:'Viewer',
        label:'Viewer'
      },
    ])
    setTeamList([
      // {
      //   value:'team1',
      //   label:'team1'
      // },
    ])
    setLicenseList([
      {
        value:'Active',
        label:'Active',
      },
      {
        value:'Deactivated',
        label:'Deactivated',
      },
      {
        value:'Expiring soon',
        label:'Expiring Soon',
      },
      {
        value:'Expired',
        label:'Expired',
      },
      {
        value:'Not Added',
        label:'Not Added',
      }
    ]),
    setManageAvailability([
      {
        value: 'true',
        label :'YES'
      },
      {
        value: 'false',
        label :'NO'
      }
    ])
  }, []);
  useEffect(() => {
    if (changeFilters) {
      onsubmitfilter();
      setChangeFilters((m) => !m);
    }
  }, [changeFilters]);

  /**
   * Handler to submit filter
   */
  const onsubmitfilter = () => {
    
    const values=Object.entries(chipArray)
    .map((value) => value[1])
    .filter(value=> value.value!==undefined)
    .map(value =>  value.value)

    const keys=Object.entries(chipArray)
    .map((value) => value[1])
    .filter(value=> value.value!==undefined)
    .map(value =>  value.type)

    const filter= {}
    const temp=Object.values(chipArray)
    temp.forEach((element)=>{
      if(!(element.type in filter))
      filter[element.type]=[];
      if(element.value)
      filter[element.type].push(element.value);
    })



    filteredData(keys, filter);
    handlepopovercloseclick()
    return;

  };

  /**
   * Handler to remove tag
   * @param {*} value
   */
  const removetag = (value, update = true) => {
    let temp = { ...chipArray };
    if(temp[value]==undefined)
    return;
    temp[value].checked = false;
    if (data.includes(value)) {
      let typeOfFilter = temp[value].type; //blood
      Object.values(temp).map((f) => {
        if (f.type === typeOfFilter) {
          f.checked = false;
        }
      });
    }
  
    const relevantObjects = Object.entries(temp) // converts each entry to [key, value]
  .filter(([k, v]) =>{ 
  return(
  v.value !== value)}) // define the criteria to include/exclude items
  .reduce((acc, [k, v]) => {
    acc[k] = v;
    return acc; // this function can be improved, it converts the [[k, v]] back to {k: v, k: v, ...}
  }, {});
    // setchipArray(temp);
    setchipArray(relevantObjects);

     if (temp[value].type === 'role') {
      let temp2 = [...selectedRole];
      let indx = temp2.findIndex((item) => item.value === temp[value].value);
      temp2.splice(indx, 1);
      setSelectedRole((t) => temp2);
    }
    if (temp[value].type === 'team') {
      let temp2 = [...selectedTeam];
      let indx = temp2.findIndex((item) => item.value === temp[value].value);
      temp2.splice(indx, 1);
      setSelectedTeam((t) => temp2);
    }
    if (temp[value].type === 'status') {
      let temp2 = [...selectedLicense];
      let indx = temp2.findIndex((item) => item.value === temp[value].value);
      temp2.splice(indx, 1);
      setSelectedLicense((t) => temp2);
    }
    if (temp[value].type === 'availability') {
      let temp2 = [...selectedManageAvailability];
      let indx = temp2.findIndex((item) => item.value === temp[value].value);
      temp2.splice(indx, 1);
      setSelectedManageAvailability((t) => temp2);
    }
    if (update) {
      setChangeFilters(true);
    }
  };
  /**
   * On change function for coach
   * @param {*} item
   * @param {*} e
   */

  const onChangeSelectRole = (item) => {
    //setting all coach as false
    chipArray['role'].checked = false;
    // let checked = e.target.checked;
    let temp = { ...chipArray };
    item.checked = !item.checked;
    item.type = 'role';
    if (item.checked) {
      temp[item.value] = item;
      setSelectedRole((m) => [...m, item]);
      setchipArray(temp);
    } else {
      removetag(item.value, false);
    }
  };
  const onChangeSelectTeam = (item) => {
    //setting all coach as false
    chipArray['team'].checked = false;
    // let checked = e.target.checked;
    let temp = { ...chipArray };
    item.checked = !item.checked;
    item.type = 'team';
    if (item.checked) {
      temp[item.value] = item;
      setSelectedTeam((m) => [...m, item]);
      setchipArray(temp);
    } else {
      removetag(item.value, false);
    }
  };
  const onChangeStatus = (item) => {
    //setting all coach as false
    chipArray['status'].checked = false;
    // let checked = e.target.checked;
    let temp = { ...chipArray };
    item.checked = !item.checked;
    item.type = 'status';
    if (item.checked) {
      temp[item.value] = item;
      setSelectedLicense((m) => [...m, item]);
      setchipArray(temp);
    } else {
      removetag(item.value, false);
    }
  };
  const onChangeAvailabilty = (item) => {
    //setting all coach as false
    chipArray['availability'].checked = false;
    // let checked = e.target.checked;
    let temp = { ...chipArray };
    item.checked = !item.checked;
    item.type = 'availability';
    if (item.checked) {
      temp[item.value] = item;
      setSelectedManageAvailability((m) => [...m, item]);
      setchipArray(temp);
    } else {
      removetag(item.value, false);
    }
  };

  const showChip = (value) => {
    let typeOfFilter = value[1]&&value[1].type;
    let temp = { ...chipArray };
    let allTrue = false;
    if (typeOfFilter) {
      allTrue = temp[typeOfFilter].checked;
    }
    if (value[1].checked === true && !allTrue) {
      return (
        <React.Fragment>
          <Chip
            variant="outlined"
            className={classes.chipfont}
            key={value[0]}
            label={
              value[0].includes('status') ? `Status - ${value[1].name}` : `${value[1].label}`
            }
            onDelete={() => removetag(value[0])}
          />
          &nbsp;
        </React.Fragment>
      );
    }
  };
  return (
    <React.Fragment>
      <Grid
        alignItems="flex-start"
        spacing={0}
        className={classes.paddingTopmainmenu}
        container
        justify="space-between"
        style={{ display: '-ms-flexbox', background: '#fff', width:'800px' }}
      >
        <Grid item>
          <Grid
            alignItems="center"
            spacing={2}
            container
            justify="flex-start"
            style={{ margin: '5px' }}
          >
            <Grid item>
              <Typography
                fontFamily="Work Sans"
                fontSize="16px"
                fonStyle="normal"
                fontWeight={600}
                lineHeight="20px"
                color="#142A39"
              >
                Filter
              </Typography>
            </Grid>
            <Grid item>
              <IconButton onClick={handlepopover2openClick} aria-label="Search">
                <FilterListIcon />
              </IconButton>
            </Grid>
            <Grid item>
              {chipArray &&
                Object.entries(chipArray).map((value) => {
                  return showChip(value);
                })}
              {/* {chipArray && showAllIfAny()} */}
            </Grid>
          </Grid>
          <Popover
            id={popoverid2}
            open={popoveropen2}
            anchorEl={anchorE2}
            className={classes.popper}
            modifiers={{
              preventOverflow: {
                enabled: false,
                boundariesElement: 'window',
              },
              arrow: {
                enabled: true,
                //element: arrowRef,
              },
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <Grid
              item
              container
              justify="flex-end"
              alignItems="flex-end"
              direction="row"
              spacing={2}
            >
              <Grid item>
                <IconButton aria-label="close" onClick={handlepopovercloseclick}>
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              className={classes.popovergrid2}
            > 
              <Grid container> 
            {/* <Grid  item xs={6} style={{padding:'1rem'}} >
            <Typography>Team</Typography>
            <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple='false'
                    value={selectedTeam.length>0? selectedTeam:['Select Team']}
                    input={<OutlinedInput label="Select Coach(s)" />}
                    renderValue={() =>
                      selectedTeam.length > 0 ? selectedTeam.map((m) => m.label).join(',') : ['Select Team']
                    }
                    style={{
                      width: '300px',
                      pointerEvents: 'none'
                    }}
                  >
                     {teamList.map((item, i) => {
                      return (
                        <MenuItem
                          // onClick={() => onChangeSelectTeam(item)}
                          key={i}
                          value={item}
                          style={{ display: 'flex', justifyContent: 'space-between' }}
                        >
                           <ListItemIcon>
              <GreenCheckbox
                edge="start"
                checked={chipArray[item.value] && chipArray[item.value].checked}
                tabIndex={-1}
                disableRipple
                onClick={() => onChangeSelectTeam(item)}
                // 
              />
            </ListItemIcon>
                          <ListItemText primary={item.label} />
                        </MenuItem>
                      );
                    })} 
                  </Select>
            </Grid> */}
            <Grid  item xs={6} style={{padding:'1rem'}} >
            <Typography>Roles</Typography>
            <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple={'false'}
                    value={selectedRole.length > 0? selectedRole : ['Select Role']}
                    input={<OutlinedInput label="Select Roles(s)" />}
                    renderValue={() =>
                      selectedRole.length > 0 ? selectedRole.map((m) => m.label).join(',') : ['Select Role']
                    }
                    style={{
                      width: '300px'
                    }}
                    // MenuProps={MenuProps}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left"
                      },
                      getContentAnchorEl: null
                    }}
                  >
                    {roleList.map((item, i) => {
                      return (
                        <MenuItem
                          // onClick={() => onChangeSelectRole(item)}
                          key={i}
                          value={item}
                          style={{ display: 'flex', justifyContent: 'space-between' }}
                        >
                                       <ListItemIcon>
              <GreenCheckbox
                edge="start"
                checked={chipArray[item.value] && chipArray[item.value].checked}
                tabIndex={-1}
                disableRipple
                onClick={() => onChangeSelectRole(item)}
                // 
              />
            </ListItemIcon>
                          <ListItemText primary={item.label} />
                          {/* {chipArray[item.value] && chipArray[item.value].checked && (
                            <DoneIcon style={{ color: '#067F6F' }} />
                          )} */}
                        </MenuItem>
                      );
                    })}
                  </Select>
            </Grid>
            <Grid  item xs={6} style={{padding:'1rem'}} >
            <Typography>License Status</Typography>
            <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple='false'
                    value={selectedLicense.length>0? selectedLicense:['Select Status']}
                    input={<OutlinedInput label="Select Coach(s)" />}
                    renderValue={() =>
                      selectedLicense.length > 0 ? selectedLicense.map((m) => m.label).join(',') : ['Select Status']
                    }
                    style={{
                      width: '300px',
                    }}
                    // MenuProps={MenuProps}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left"
                      },
                      getContentAnchorEl: null
                    }}
                  >
                    {licenseList.map((item, i) => {
                      return (
                        <MenuItem
                          key={i}
                          value={item}
                          style={{ display: 'flex', justifyContent: 'space-between' }}
                        >
                           <ListItemIcon>
              <GreenCheckbox
                edge="start"
                checked={chipArray[item.value] && chipArray[item.value].checked}
                tabIndex={-1}
                disableRipple
                onClick={() => onChangeStatus(item)}
                // 
              />
            </ListItemIcon>
                          <ListItemText primary={item.label} />
                        </MenuItem>
                      );
                    })}
                  </Select>
            </Grid>
           </Grid>
           <Grid container> 
            <Grid  item xs={6} style={{padding:'1rem'}} >
            <Typography>Manage Availability</Typography>
            <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple='false'
                    value={selectedManageAvailability.length>0? selectedManageAvailability:['Select Choice']}
                    input={<OutlinedInput label="Select Coach(s)" />}
                    renderValue={() =>
                      selectedManageAvailability.length > 0 ? selectedManageAvailability.map((m) => m.label).join(',') : ['Select Choice']
                    }
                    style={{
                      width: '300px',
                    }}
                    // MenuProps={MenuProps}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left"
                      },
                      getContentAnchorEl: null
                    }}
                  >
                    {manageAvailability.map((item, i) => {
                      return (
                        <MenuItem
                          // onClick={() => onChangeSelectTeam(item)}
                          key={i}
                          value={item}
                          style={{ display: 'flex', justifyContent: 'space-between' }}
                        >
                           <ListItemIcon>
              <GreenCheckbox
                edge="start"
                checked={chipArray[item.value] && chipArray[item.value].checked}
                tabIndex={-1}
                disableRipple
                onClick={() => onChangeAvailabilty(item)}
                // 
              />
            </ListItemIcon>
                          <ListItemText primary={item.label} />
                          {/* {chipArray[item.value] && chipArray[item.value].checked && (
                            <DoneIcon style={{ color: '#067F6F' }} />
                          )} */}
                        </MenuItem>
                      );
                    })}
                  </Select>
            </Grid>
           </Grid>
              <Grid
                item
                container
                justify="flex-end"
                alignItems="center"
                direction="row"
                spacing={2}
                
              >
                <Grid item >
                  <Button className={classes.buttonstyle} onClick={handlepopoverresetclick2}>
                    <Typography
                      fontSize="14px"
                      lineHeight="16.42px"
                      fontFamily="Work Sans"
                      letterSpacing="0.75px"
                      fontWeight={700}
                      color="#067f6f"
                      fontWeight= 'bold'
                      textTransform='uppercase'
                    >
                      {'CLEAR ALL'}
                    </Typography>
                  </Button>
                </Grid>
                <Grid item >
                  <div className='telekardia'>
                    <button
                      type="button"
                      className={classes.apply}
                      onClick={onsubmitfilter}
                    >
                      {'APPLY'}
                    </button>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            {/* </Paper> */}
          </Popover>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

export default Filter;



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/NewTeamMembers/components/Filter.jsx